import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as style from './styles.css';
export var Preloader = function Preloader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, mergeStyles(style['preloader'], props.customStyle), {
    viewBox: "0 0 40 40"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: style['preloader'],
    gradientUnits: "userSpaceOnUse",
    y1: "30",
    x2: "40",
    y2: "30"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#0076eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff",
    stopOpacity: "0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(style['preloader'], ")"),
    d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"
  }));
};